export interface SystemTag {
  id: number;
  name: SystemTagName;
}

export enum SystemTagName {
  Delete = 'delete',
}
